import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { avanzoApi } from "./avanzoApi";

/**
 * useB2CAccess — polls /avanzo-b2c/access once and returns the
 * probe result. Institutional users get 401/403 → not allowed.
 */
export function useB2CAccess() {
  const [state, setState] = useState({
    loading: true,
    allowed: false,
    access: null,
    reason: null,
  });

  useEffect(() => {
    let cancelled = false;
    avanzoApi
      .access()
      .then((r) => {
        if (cancelled) return;
        setState({ loading: false, allowed: true, access: r.data, reason: null });
      })
      .catch((err) => {
        if (cancelled) return;
        const status = err?.response?.status;
        setState({
          loading: false,
          allowed: false,
          access: null,
          reason: status === 401 ? "unauthenticated" : "not_b2c",
        });
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return state;
}

/**
 * B2CGuard — wrap any /avanzo/* page. Redirects:
 *   - unauthenticated → /login
 *   - authenticated but not B2C → /dashboard (they'll see their own home)
 */
export function B2CGuard({ children }) {
  const { loading, allowed, reason, access } = useB2CAccess();

  if (loading) {
    return (
      <div className="avz-shell">
        <div className="avz-container">
          <div className="avz-empty" data-testid="b2c-loading">
            Cargando tu preparación…
          </div>
        </div>
      </div>
    );
  }
  if (!allowed) {
    if (reason === "unauthenticated") return <Navigate to="/login" replace />;
    return <Navigate to="/dashboard" replace />;
  }
  // Provide access data via React context (light, no external lib)
  return React.cloneElement(children, { avanzoAccess: access });
}

/** Same but as HOC for functional composition. */
export function withB2CGuard(Component) {
  return function Guarded(props) {
    return (
      <B2CGuard>
        <Component {...props} />
      </B2CGuard>
    );
  };
}
